/* Wanderest v8: faster testimonials, swipe on mobile, copy protection */
(function () {
  var SPEED = 3500; /* ms per testimonial */
  function next(wrap, dir) {
    var dots = wrap.querySelectorAll('.quotes__dot'); if (dots.length < 2) return;
    var cur = 0; dots.forEach(function (d, i) { if (d.classList.contains('is-active')) cur = i; });
    dots[(cur + dir + dots.length) % dots.length].click();
  }
  function init() {
    document.querySelectorAll('[data-quotes]').forEach(function (wrap) {
      if (wrap.dataset.swipe) return; wrap.dataset.swipe = '1';
      var hover = false, last = Date.now();
      wrap.addEventListener('mouseenter', function () { hover = true; });
      wrap.addEventListener('mouseleave', function () { hover = false; last = Date.now(); });
      wrap.addEventListener('click', function () { last = Date.now(); });
      setInterval(function () {
        if (hover || document.hidden || Date.now() - last < SPEED) return;
        next(wrap, 1);
      }, 200);
      var x0 = null, y0 = null;
      wrap.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        next(wrap, dx < 0 ? 1 : -1);
      }, { passive: true });
    });
  }
  /* block copying text and saving images (form fields still work) */
  var editor = window.Shopify && Shopify.designMode;
  function editable(t) { return t && t.closest && t.closest('input, textarea, select, [contenteditable]'); }
  ['copy', 'cut'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (!editor && !editable(e.target)) e.preventDefault(); });
  });
  document.addEventListener('contextmenu', function (e) { if (!editor && !editable(e.target)) e.preventDefault(); });
  document.addEventListener('dragstart', function (e) { if (e.target && (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO')) e.preventDefault(); });
  /* fade-in for the buy-box blocks too (long on mobile) */
  function heroFade() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (editor || reduce || !('IntersectionObserver' in window)) return;
    var info = document.querySelector('.pdp__info'); if (!info) return;
    info.classList.remove('wr-enter');
    var box = info.querySelector('form') || info;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    var n = 0;
    Array.prototype.forEach.call(box.children, function (el) {
      if (!el.offsetHeight || el.tagName === 'INPUT' || el.classList.contains('wr-fade')) return;
      el.style.transitionDelay = Math.min(n++, 4) * 70 + 'ms';
      el.classList.add('wr-fade');
      io.observe(el);
    });
  }
  function start() { init(); heroFade(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
